import type { AlertColor } from '@mui/material'

import { useState } from 'react'

import type { ArticleAttachment } from '../types/article.types'

type ShowSnackbar = (message: string, severity?: AlertColor) => void

export function useArticleResources(showSnackbar: ShowSnackbar) {
  const [files, setFiles] = useState<File[]>([])
  const [images, setImages] = useState<File[]>([])
  const [existingAttachments, setExistingAttachments] = useState<ArticleAttachment[]>([])
  const [pendingDeletedAttachmentIds, setPendingDeletedAttachmentIds] = useState<number[]>([])

  function setLoadedAttachments(attachments: ArticleAttachment[]) {
    setExistingAttachments(attachments)
    setPendingDeletedAttachmentIds([])
  }

  function deleteExistingAttachment(attachmentId: number) {
    setExistingAttachments((current) => current.filter((attachment) => attachment.id !== attachmentId))
    setPendingDeletedAttachmentIds((current) => (current.includes(attachmentId) ? current : [...current, attachmentId]))
    showSnackbar('Attachment will be deleted when you save')
  }

  function clearPendingResources() {
    setPendingDeletedAttachmentIds([])
    setFiles([])
    setImages([])
  }

  return {
    clearPendingResources,
    deleteExistingAttachment,
    existingAttachments,
    files,
    images,
    pendingDeletedAttachmentIds,
    setExistingAttachments,
    setFiles,
    setImages,
    setLoadedAttachments,
    setPendingDeletedAttachmentIds,
  }
}
